import {
  Component, EventEmitter, Input, Output
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ITEMS_PER_PAGE } from 'app/constants';

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss']
})
export class TablePaginationComponent {
  dropdownData: Record<string, any> = {
    itemsPerPage: ITEMS_PER_PAGE
  };

  @Input() isNextPageDisabled = true;

  @Input() isPrevPageDisabled = true;

  @Input() form!: UntypedFormGroup;

  @Input() controlName!: string;

  @Output() onPreviousPage = new EventEmitter();

  @Output() onNextPage = new EventEmitter();

  previousPage(): void {
    this.onPreviousPage.emit();
  }

  nextPage(): void {
    this.onNextPage.emit();
  }
}
